import cn from 'classnames';
import { Tooltip } from 'react-tooltip';
import styles from '../Filter.module.scss';

interface FilterMenuItemProps {
  filter: {
    name: string;
    count: number;
    content: React.ReactNode;
    isExclude?: boolean;
    disabled?: boolean;
    tooltipText?: string;
  };
  isActive: boolean;
  isDisabled?: boolean;
  tooltipText?: string;
  onClick: () => void;
}

export const FilterMenuItem: React.FC<FilterMenuItemProps> = ({ filter, isActive, isDisabled, tooltipText, onClick }) => {
  return (
    <div
      className={cn(styles.menuItem, { [styles.menuItemActive]: isActive, [styles.menuItemDisabled]: isDisabled })}
      onClick={onClick}
      data-tooltip-id={isDisabled ? `tooltip-${filter.name.replace(/\s+/g, '-').toLowerCase()}` : undefined}
      data-tooltip-content={isDisabled ? tooltipText : undefined}
    >
      <span>{filter.name}</span>
      {filter.count > 0 ? <div className={cn(styles.menuItemCount, filter.isExclude ? styles.countExclude : '')}>{filter.count}</div> : null}

      {isDisabled && tooltipText && (
        <Tooltip
          id={`tooltip-${filter.name.replace(/\s+/g, '-').toLowerCase()}`}
          place="right"
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            color: '#fff',
            borderRadius: '4px',
            padding: '8px 12px',
            fontSize: '14px',
            maxWidth: '350px',
            textAlign: 'center',
            zIndex: 9999
          }}
        />
      )}
    </div>
  );
};
